import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../lib/utils';

const badgeVariants = cva(
  'inline-flex max-w-full items-center rounded-md border px-2 py-0.5 font-body text-caption font-semibold uppercase tracking-normal',
  {
    variants: {
      variant: {
        compliant: 'bg-emerald-50 text-emerald-800 border-emerald-200',
        'non-compliant': 'bg-red-50 text-red-800 border-red-200',
        warning: 'bg-amber-50 text-amber-800 border-amber-200',
        pending: 'bg-indigo-50 text-indigo-800 border-indigo-200',
        draft: 'bg-slate-100 text-slate-600 border-slate-300',
        success: 'bg-emerald-50 text-emerald-800 border-emerald-200',
        error: 'bg-red-50 text-red-800 border-red-200',
        info: 'bg-indigo-50 text-indigo-800 border-indigo-200',
      },
    },
    defaultVariants: {
      variant: 'draft',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
